export default "__VITE_ASSET__B3BqDuYO__"